import React, { useEffect, useState } from 'react'
import './index.css'
import { fetchUsers, fetchUserWeddings } from '../../../endpoint/index.ts'
import { useAppDispatch, useAppSelector } from '../../../store/index.ts'
import { Link, useNavigate } from 'react-router-dom'
import { setSelectedPartnerWeddings, setUsers } from '../../../store/userSlice.ts'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { IUser } from '../../../interface/index.ts'

const Partners : React.FC = () => {
	const { userData, users, selectedPartnerWeddings } = useAppSelector(({ userData }) => userData)

	const today = new Date()
	const currentMonth = today.getMonth() + 1
	const previousMonth = today.getMonth()

	const dispatch = useAppDispatch()
	const [showPartnerModal, setShowPartnerModal] = useState<boolean>(false)
	const [selectedPartner, setSelectedPartner] = useState<IUser>()

	const handleClosePartnerModal = () => setShowPartnerModal(false)
	const handleShowPartnerModal = async (user: IUser) => {
		console.log(user, ' user')
		const partnerWeddings = await fetchUserWeddings(user)

		dispatch(setSelectedPartnerWeddings(partnerWeddings))
		setSelectedPartner(user)
		setTimeout(() => {
			setShowPartnerModal(true)
		}, 200)
	}

	const navigate = useNavigate()

	useEffect(() => {
		getUsers()
	}, [])

	const getUsers = async () => {
		if (userData) {
			const users = await fetchUsers()

			dispatch(setUsers(users))
			return
		}

		navigate('/admin')
	}

	const getCurrentMonthWeddings = () => {
		const currentMonthWeddings = selectedPartnerWeddings.filter((wedding) => {
			const weddingDate = new Date(wedding.data.dateStart)
			return weddingDate.getMonth() + 1 === currentMonth
		})

		return currentMonthWeddings
	}

	const getPreviousMonthWeddings = () => {
		const previousMonthWeddings = selectedPartnerWeddings.filter((wedding) => {
			const weddingDate = new Date(wedding.data.dateStart)
			return weddingDate.getMonth() + 1 === previousMonth
		})

		return previousMonthWeddings
	}

	const getWeddingPackages = (weddingMonth: 'current' | 'previous' = 'current') => {
		if (weddingMonth === 'current') {
			const currentMonthWeddings = getCurrentMonthWeddings()
			let packageOption1Count = 0
			let packageOption2Count = 0
			let packageOption3Count = 0
			currentMonthWeddings.forEach((wedding) => {
				if (wedding.packageOption === '1') {
					packageOption1Count++
				}
				if (wedding.packageOption === '2') {
					packageOption2Count++
				}
				if (wedding.packageOption === '3') {
					packageOption3Count++
				}
			})

			return {
				packageOption1Count,
				packageOption2Count,
				packageOption3Count
			}
		}

		const currentMonthWeddings = getPreviousMonthWeddings()
		let packageOption1Count = 0
		let packageOption2Count = 0
		let packageOption3Count = 0
		currentMonthWeddings.forEach((wedding) => {
			if (wedding.packageOption === '1') {
				packageOption1Count++
			}
			if (wedding.packageOption === '2') {
				packageOption2Count++
			}
			if (wedding.packageOption === '3') {
				packageOption3Count++
			}
		})

		return {
			packageOption1Count,
			packageOption2Count,
			packageOption3Count
		}
	}

	return (
		<div className='partner-container'>
			<section className='table-container'>
				<div className='navbar-div navbar-admin'>
					<div className='navbar-container navbar-admin'>
						<div className='navbar-items-container'>
							<Link className='navbar-container-logo' to={'/admin/dashboard'}>
								<img src={require('../../../assets/weddingCamera/logo-with-text.png')}/>
							</Link>

							{
								userData?.isSuperAdmin &&
								<Link className='' to={'/admin/dashboard/partners'}>
									<h2>Partneri</h2>
								</Link>
							}
						</div>
						<h3>
							{userData?.name}
						</h3>
					</div>
				</div>

				<div className='partner-content-container'>
					<div className='wedding-table-header'>
						<h3>Partneri</h3>
					</div>
					<table className="table wedding-table align-middle mb-0 bg-white">
						<thead className="bg-light">
							<tr>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										ID
									</span>
								</th>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										Ime
									</span>
								</th>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										Ime obrta
									</span>
								</th>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										Adresa obrta
									</span>
								</th>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										OIB
									</span>
								</th>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										Maticni broj
									</span>
								</th>
								<th className='text-center'>
									<span style={{ display: 'inline-flex', alignItems: 'center' }}>
										super admin
									</span>
								</th>
								<th>Aktivan</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{
								users.map((user, index) => (
									<tr key={index}>
										<td className='text-center'>{user.id}</td>
										<td className='text-center'>{user.name}</td>
										<td className='text-center'>{user.companyName}</td>
										<td className='text-center'>{user.companyAdress}</td>
										<td className='text-center'>{user.companyOib}</td>
										<td className='text-center'>{user.maticniBroj}</td>
										<td className='text-center'>{user.isSuperAdmin ? 'Da' : 'Ne'}</td>
										<td className='text-center'>{user.isActive ? 'Da' : 'Ne'}</td>
										<td className='text-center'>
											<button className='btn btn-link btn-sm btn-rounded' onClick={() => handleShowPartnerModal(user)}>Prikaži</button>
										</td>
									</tr>
								))
							}
						</tbody>
					</table>
				</div>
			</section>

			<Modal className='modal' scrollable show={showPartnerModal} onHide={handleClosePartnerModal}>
				<Form>
					<Modal.Header closeButton>
						<Modal.Title>{selectedPartner?.name}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className='sold-weddings-modal-section-current-month'>
							<h2><u>Tekući mjesec ({currentMonth}.)</u></h2>
							<div>
								{getCurrentMonthWeddings().length}
							</div>

							<div>
								<h2>Prodani paketi</h2>
								<div>
									<div>
										<div className='package-container-row'>
											<div>
												<h3>Paket 1 (79€)</h3>
												<p>{getWeddingPackages('current').packageOption1Count}</p>
											</div>

											<div>
												<p>Za naplatu</p>
												<p><strong>{getWeddingPackages('current').packageOption1Count * 79}€</strong></p>
											</div>
										</div>
									</div>
									<div>
										<div className='package-container-row'>
											<div>
												<h3>Paket 2 (99€)</h3>
												<p>{getWeddingPackages('current').packageOption2Count}</p>
											</div>
											<div>
												<p>Za naplatu</p>
												<p><strong>{getWeddingPackages('current').packageOption2Count * 99}€</strong></p>
											</div>
										</div>
									</div>
									<div>
										<div className='package-container-row'>
											<div>
												<h3>Paket 3 (129€)</h3>
												<p>{getWeddingPackages('current').packageOption3Count}</p>
											</div>
											<div>
												<p>Za naplatu</p>
												<p><strong>{getWeddingPackages('current').packageOption3Count * 129}€</strong></p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className='divider'></div>

						<div className='sold-weddings-modal-section-previous-month'>
							<h2><u>Prošli mjesec ({previousMonth}.)</u></h2>
							<div>
								{getPreviousMonthWeddings().length}
							</div>

							<div>
								<h2>Prodani paketi</h2>
								<div>
									<div>
										<div className='package-container-row'>
											<div>
												<h3>Paket 1 (79€)</h3>
												<p>{getWeddingPackages('previous').packageOption1Count}</p>
											</div>
											<div>
												<p>Za naplatu</p>
												<p><strong>{getWeddingPackages('previous').packageOption1Count * 79}€</strong></p>
											</div>
										</div>
									</div>
									<div>
										<div className='package-container-row'>
											<div>
												<h3>Paket 2 (99€)</h3>
												<p>{getWeddingPackages('previous').packageOption2Count}</p>
											</div>
											<div>
												<p>Za naplatu</p>
												<p><strong>{getWeddingPackages('previous').packageOption2Count * 99}€</strong></p>
											</div>
										</div>
									</div>
									<div>
										<div className='package-container-row'>
											<div>
												<h3>Paket 3 (129€)</h3>
												<p>{getWeddingPackages('previous').packageOption3Count}</p>
											</div>
											<div>
												<p>Za naplatu</p>
												<p><strong>{getWeddingPackages('previous').packageOption3Count * 129}€</strong></p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={handleClosePartnerModal}>
							Zatvori
						</Button>
						<Button variant="primary" type='submit'>
							Kreiraj
						</Button>
					</Modal.Footer>
				</Form>
			</Modal>
		</div>

	)
}

export default Partners
